module.exports = __webpack_public_path__ + "static/img/IMG_20160615_002236.2a2ab9a4.jpg";